import styled, { css } from 'styled-components';

export const ConvertMilageModal = styled.div`
  padding: ${({ theme }) => `${theme.spacing.x3} ${theme.spacing.x5}`};
`;
export const ModalType1 = styled.div`
  font-weight: bold;
  font-size: ${({ theme }) => theme.fs.md};
  text-align: center;
`;
export const ModalType2 = styled.div`
  margin: ${({ theme }) => `${theme.spacing.x3} 0`};
  text-align: center;
`;
export const ModalType3 = styled.div`
  padding: ${({ theme }) => theme.spacing.x4};
  margin-bottom: ${({ theme }) => theme.spacing.x3};

  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
`;
export const ModalType5 = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ConvertMilesReceipt = styled.div`
  padding: ${({ theme }) => ` 0 ${theme.spacing.x5} ${theme.spacing.x4}`};
`;

export const Divider = styled.div`
  margin: ${({ theme }) => ` ${theme.spacing.x4} 0`};
  border: 1px solid ${({ theme }) => theme.palette.whiteGray};
`;

export const GrayCard = styled.div`
  padding: ${({ theme }) => theme.spacing.x4};
  margin-bottom: ${({ theme }) => theme.spacing.x3};
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
`;
export const RowList = styled.div<{ $remain }>`
  ${({ $remain }) =>
    $remain
      ? css`
          border-top: 1px solid ${({ theme }) => theme.palette.whiteGray};
          padding-top: ${({ theme }) => theme.spacing.x3};
        `
      : null}
`;

export const RowListText = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const RowListGrayText = styled.div`
  color: ${({ theme }) => theme.palette.darkGray};
`;
export const RowListErrorText = styled.div`
  color: ${({ theme }) => theme.palette.error};
`;
export const RowListSuccessText = styled.div`
  color: ${({ theme }) => theme.palette.success};
`;
export const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
`;
export const BtnActiveText = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.x2};
  width: 134px;
`;
export const BtnActiveDefult = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
  width: 134px;
`;
export const CloseBtn = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const ConvertMilageModalContainer = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
  width: 566px;
  max-width: 95%;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 300px !important;
  }
`;
